import React from "react";
import { Component } from "react";
import "./Chiclet.scss";
import * as _ from "lodash";

export default class Chiclet extends Component {
  state = {
    animationName: "none",
  };

  render() {
    let { chart, toggleChart = _.noop, cKey, active, showTrends } = this.props;
    if (!chart) return null;
    if (showTrends === false) {
      toggleChart = () => {};
    }

    return (
      <div
        className={[
          _.kebabCase(chart.title),
          "chiclet",
          active ? "active" : "",
          chart.viewCategory,
          showTrends === false ? "" : "clickable",
        ].join(" ")}
        key={cKey || chart.title}
        onClick={() => toggleChart(chart, cKey)}
      >
        <div
          className="title"
          style={{
            animation: `${this.state.animationSpeed} linear infinite alternate ${this.state.animationName}`,
          }}
        >
          {chart.title}
        </div>
        <div
          className="body"
          style={
            active
              ? { background: chart.color, color: "#fff" }
              : { color: chart.color }
          }
        >
          <div className="inner">
            <div className="value" style={{ color: chart.lineColor }}>
              {
                {
                  single: this.getValue(0),
                  comp2: `${this.getValue(0)} / ${this.getValue(1)}`,
                  comp3: [`${this.getValue(0)} / ${this.getValue(1)}`],
                  stcomp: this.stCompList(),
                }[chart.viewCategory]
              }
              {chart.component}
            </div>
            {chart.viewCategory === "comp3" ? (
              <span className="mean">({this.getValue(2)})</span>
            ) : null}
            {chart.units ? <div className="unit">{chart.units}</div> : null}
            {chart.isEpisodic ? (
              <div className="time">{chart.time || "--:--"}</div>
            ) : null}
          </div>
        </div>
        <style>{this.state.keyframes}</style>
      </div>
    );
  }

  getValue(i) {
    const values = this.props.chart.values;
    if (
      values &&
      values.length > i &&
      values[i] !== null &&
      typeof values[i] !== "undefined"
    ) {
      return values[i];
    } else {
      return "--";
    }
  }

  stCompList() {
    return stCompLabels.map((label, i) => (
      <div key={label}>
        <span className="label">{label}</span>
        <span className="st-value">{this.getValue(i)}</span>
      </div>
    ));
  }
}

export const stCompLabels =
  "V,V1,V2,V3,V4,V5,V6,I,II,III,aVF,aVR,aVL,MCL".split(",");
